import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import logo from '../assets/images/logo.svg';
import contact1 from '../assets/images/contact1.jpg';
import contact2 from '../assets/images/contact2.jpg';
// import axios from "axios";
import "../App.css";
import { useIsLogin } from "../hooks";
import TopNav from "./TopNav";
import sia from "../services/Api";
import LoaderView from "../tools/LoaderView";
import { notifySuccessfulMessage } from "../App";

const Contact = () => {
	const css = `
  .cls-1{fill:#fff}
  `
	const [isLoading, setLoading] = useState(false)

	const sendEmail = async (e) => {
		setLoading(true)
		await sia.PostDataToServer('sendEmail', {
			"fullName": e.target.elements.name.value + ' ' + e.target.elements.lname.value,
			"email": e.target.elements.email.value,
			"phone": e.target.elements.phone.value,
			"subject": e.target.elements.subject.value,
			"message": e.target.elements.message.value
		}).then((res) => {
			if (res.status == 200) {
				notifySuccessfulMessage('سپاس از تماس شما؛ در اسرع وقت پاسخ داده می شود')
			}
		}).catch((err) => console.log(err))
		setLoading(false)
	}

	const isLogin = useIsLogin();
	console.log(isLogin);
	return (
		<>
			<header>
				<div className="pagewrapper slim3" id="header-slim">
					<div className="container">
						<TopNav />
					</div>
				</div>
			</header>
			<div className="clear"></div>
			{isLoading && <LoaderView />}
			<div className="pagewrapper" id="contact-address">
				<div className="container">
					<img src={contact1} alt="" width="572" height="572" />
					<div className="content">
						<h2>همین الان تماس بگیرید</h2>
						<p className="phone">09150974945 - 05138558474</p>
						<h2>آدرس:</h2>
						<p className="address">خراسان رضوی مشهد خیابان ملک الشعرا بهار مقابل استانداری خراسان رضوی</p>
						<div className="social">
							<Link to="" title="">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" className="ease" viewBox="0 0 10.944 21.886"><path fill="#fff" d="M15.133 3.634h2V.154A25.8 25.8 0 0 0 14.22 0c-2.881 0-4.854 1.812-4.854 5.142v3.065H6.187V12.1h3.179v9.789h3.9V12.1h3.05l.484-3.89h-3.537V5.528c0-1.124.3-1.894 1.87-1.894z" transform="translate(-6.187)" /></svg>
							</Link>
							<Link to="" title="">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" className="ease" viewBox="0 0 26.263 21.886"> <path fill="#fff" d="M10.305 16.424l-.434 6.111a1.519 1.519 0 0 0 1.214-.588L14 19.162l6.038 4.422c1.107.617 1.888.292 2.186-1.019l3.963-18.572c.351-1.637-.592-2.277-1.671-1.876l-23.3 8.92c-1.59.617-1.566 1.5-.27 1.905l5.956 1.853L20.74 6.137c.651-.431 1.243-.193.756.239z" transform="translate(0 -2)" /> </svg>
							</Link>
							<Link to="" title="">
								<svg xmlns="http://www.w3.org/2000/svg" id="instagram3" width="20" height="20" fill="#fff" className="ease" viewBox="0 0 21.886 21.886"> <defs><style>{css}</style></defs> <path id="Path_143" d="M15.961 0H5.923A5.931 5.931 0 0 0 0 5.924v10.038a5.931 5.931 0 0 0 5.924 5.924h10.037a5.931 5.931 0 0 0 5.924-5.924V5.924A5.931 5.931 0 0 0 15.961 0zm-5.019 16.927a5.984 5.984 0 1 1 5.984-5.984 5.991 5.991 0 0 1-5.984 5.984zM17.069 6.37a1.768 1.768 0 1 1 1.769-1.77 1.77 1.77 0 0 1-1.769 1.77zm0 0" className="cls-1" transform="translate(.001)" /> <path id="Path_144" d="M150.721 146.02a4.7 4.7 0 1 0 4.7 4.7 4.707 4.707 0 0 0-4.7-4.7zm0 0" className="cls-1" transform="translate(-139.778 -139.778)" /> <path id="Path_145" d="M388.478 96.3a.485.485 0 1 0 .485.485.486.486 0 0 0-.485-.485zm0 0" className="cls-1" transform="translate(-371.407 -92.184)" /> </svg>
							</Link>
						</div>
					</div>
				</div>
			</div>

			{/*<div className="pagewrapper" id="contact-form-wrapper">*/}
			{/*	<div className="container">*/}
			{/*		<img src={contact2} alt="" width="572" height="572" />*/}
			{/*		<div className="content">*/}
			{/*			<h2>فرم تماس</h2>*/}
			{/*			<form onSubmit={sendEmail} id="contact-form" method="post">*/}
			{/*				<input type="text" name="fname" placeholder="نام" className="text box-sizing radius3" />*/}
			{/*				<input type="text" name="lname" placeholder="نام خانوادگی" className="text box-sizing radius3" />*/}
			{/*				<input type="email" name="email" placeholder="ایمیل" className="text box-sizing radius3" />*/}
			{/*				<input type="number" name="phone" placeholder="شماره تماس" className="text box-sizing radius3" />*/}
			{/*				<input type="text" name="subject" placeholder="موضوع" className="text full box-sizing radius3" />*/}
			{/*				<textarea name="message" placeholder="توضیحات" className="text message box-sizing radius3"></textarea>*/}
			{/*				<div className="submit ease box-sizing">*/}
			{/*					ارسال*/}
			{/*					<span><svg version="1.1" fill="#fff" x="0px" y="0px" width="16px" height="12px" viewBox="0 0 123.725 123.725" style={{ enableBackground: "new 0 0 123.725 123.725" }} xmlSpace="preserve"> <g> <path d="M2.325,67.002l38.6,30c3.9,3.101,9.7,0.3,9.7-4.7V81.902c0-3.3,2.6-5.9,5.899-5.9h61.5c3.301,0,5.7-2.8,5.7-6.1v-16.1 c0-3.3-2.399-5.8-5.7-5.8h-61.5c-3.3,0-5.899-2.9-5.899-6.2v-10.3c0-5-5.8-7.9-9.8-4.8l-38.5,30.8 C-0.775,59.902-0.775,64.603,2.325,67.002z" /> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></span>*/}
			{/*					<input type="submit" style={{ display: 'none' }} className="btn" />*/}
			{/*				</div>*/}
			{/*			</form>*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*</div>*/}

			<div className="clear"></div>
		</>
	);
};

export default Contact;
